import RouteUtils from '~/core/utils/RouteUtils';

import {policyPaths} from '~/paths';

const routes = [
	{
		path: policyPaths.policyPaymentPage,
		title: 'Make a payment',
		isDynamicRouteRequired: false,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PaymentPage');
		}),
	},
	{
		path: policyPaths.policyPaymentReceivedPage,
		title: 'Payment Received',
		isDynamicRouteRequired: false,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PaymentReceivedPage');
		}),
	},
];

export default routes;
